export default ({
    icon: iconData = { url: '' },
    image: imageData = { url: '' },
    sponsoredBy = '',
    title = '',
    clickUrl = '',
    imageRatio = 0,
}) => `
    <a href="${clickUrl}" target="_blank">
        <div class="image-container">
            <div class="ratio-container" style="padding-bottom: ${imageRatio}%;">
                <img src="${imageData.url}" alt="${title}" class="image">
            </div>
            <img src="${iconData.url}" alt="${sponsoredBy}" class="icon">
        </div>
        <div class="text-wrap">
            <span class="sponsored-by">Annonse fra ${sponsoredBy}</span>
            <h4 class="title">${title}</h4>
        </div>
    </a>
`;



/** WEBPACK FOOTER **
 ** ./src/ads/native-templates/default.js
 **/